<template>
  <article :id="'post-' + id">

    <!-- post title -->
    <v-row no-gutters>
      <v-col cols="12">
        <slot name="video"></slot>
        <div class="ch-post__title text-h4 font-weight-bold text--caslon my-1 secondary--text" v-html="title"></div>
      </v-col>
    </v-row>

  <v-row>
    <!-- meta column -->
    <v-col cols="12" class="d-flex d-lg-none py-0">
      <post-meta-row
        :category="category"
        :posted-by="postedBy"
        :posted-on="postedOn"
      ></post-meta-row>
    </v-col>

    <v-col cols="12" md="3" class="d-none d-lg-block">
      <!-- article meta -->
      <post-meta
        :author="postedBy"
        :category="category"
        :image="authorImage"
        :posted-by="postedBy"
        :posted-on="postedOn"
        :twitter="authorTwitter"
      ></post-meta>
      <!-- related articles -->
      <related-posts class="d-print-none" :items="relatedArticles"></related-posts>
    </v-col>

    <!-- post column -->
    <v-col cols="12" md="9">

      <v-card flat class="ch-post__content entry-content transparent secondary--text">
        <slot name="default"></slot>
      </v-card>

      <!-- categories -->
      <post-categories :items="categories"></post-categories>
       <!-- tags -->
       <post-tags :items="tags"></post-tags>
      <!-- social -->
      <post-social :link="socialLink" :title="socialTitle"></post-social>
    </v-col>

  </v-row>
  
</article>
</template>

<script>
  import PostCategories from './single/Categories.vue'
  // import PostFeaturedImage from './single/FeaturedImage.vue'
  import PostMeta from './single/Meta.vue'
  import PostMetaRow from './single/MetaRow.vue'
  import PostSocial from './single/Social.vue'
  import PostTags from './single/Tags.vue'
  import RelatedPosts from './single/Related.vue'

  export default {
    name: 'SinglePost',

    props: [
      'id', 
      'image', 
      'title', 
      'category',
      'categories',
      'tags',
      'posted-on', 
      'posted-by', 
      'author-image', 
      'related-articles', 
      'author-twitter',
      'social-title',
      'social-link'
    ],

    computed: {
      isSponsored() {
        return this.category && this.category.name == 'Sponsored'
      }
    },

    components: {
      PostCategories,
      // PostFeaturedImage,
      PostMeta,
      PostMetaRow,
      PostSocial,
      PostTags,
      RelatedPosts
    }
  }
</script>
